export default __webpack_public_path__ + "static/PromptIconNine-e1f3a3a2753e9a4b44b9bb44d8e9a36a.png";